import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, ICardData } from "@tylertech/tyler-api-types";

@Injectable()
export class DetailDialogService
{
    constructor(
        private readonly $apiService: ApiService
    ) { }

    getDetail(endpoint: string, model: unknown): Promise<ExecutionResult<Array<ICardData>>>
    {
        return this.$apiService.sendAuth(endpoint, model);
    }
}
